<template>
  <div class="content content_in">
    <div class="title-row row justify-content-between">
      <div class="col-12 col-md-auto">
        <h1>{{ $t("platforms.postback.global_title") }}</h1>
      </div>
    </div>
    <PostbackLogs />
  </div>
</template>
<script>
import PostbackLogs from "@/components/PlatformCard/PostbackLogs.vue";

// Postbacks of all platforms. The log of one platform is on its card.
export default {
  name: "Postbacks",
  components: { PostbackLogs },
};
</script>
